export const iconList = [
    {"name": "filesync", "icon": "icon-filesync"},
    {"name": "file-zip-fill", "icon": "icon-file-zip-fill"},
    {"name": "filesearch", "icon": "icon-filesearch"},
    {"name": "file-pdf-fill", "icon": "icon-file-pdf-fill"},
    {"name": "solution", "icon": "icon-solution"},
    {"name": "file-image-fill", "icon": "icon-file-image-fill"},
    {"name": "fileprotect", "icon": "icon-fileprotect"},
    {"name": "diff-fill", "icon": "icon-diff-fill"},
    {"name": "file-add", "icon": "icon-file-add"},
    {"name": "file-copy-fill", "icon": "icon-file-copy-fill"},
    {"name": "file-excel", "icon": "icon-file-excel"},
    {"name": "snippets-fill", "icon": "icon-snippets-fill"},
    {"name": "file-exclamation", "icon": "icon-file-exclamation"},
    {"name": "batchfolding-fill", "icon": "icon-batchfolding-fill"},
    {"name": "file-pdf", "icon": "icon-file-pdf"},
    {"name": "reconciliation-fill", "icon": "icon-reconciliation-fill"},
    {"name": "file-image", "icon": "icon-file-image"},
    {"name": "folder-add-fill", "icon": "icon-folder-add-fill"},
    {"name": "file-markdown", "icon": "icon-file-markdown"},
    {"name": "folder-fill", "icon": "icon-folder-fill"},
    {"name": "file-unknown", "icon": "icon-file-unknown"},
    {"name": "folder-open-fill", "icon": "icon-folder-open-fill"},
    {"name": "file-ppt", "icon": "icon-file-ppt"},
    {"name": "database-fill", "icon": "icon-database-fill"},
    {"name": "file-word", "icon": "icon-file-word"},
    {"name": "container-fill", "icon": "icon-container-fill"},
    {"name": "file", "icon": "icon-file"},
    {"name": "sever-fill", "icon": "icon-sever-fill"},
    {"name": "file-zip", "icon": "icon-file-zip"},
    {"name": "calendar-check-fill", "icon": "icon-calendar-check-fill"},
    {"name": "file-text", "icon": "icon-file-text"},
    {"name": "image-fill", "icon": "icon-image-fill"},
    {"name": "file-copy", "icon": "icon-file-copy"},
    {"name": "idcard-fill", "icon": "icon-idcard-fill"},
    {"name": "snippets", "icon": "icon-snippets"},
    {"name": "creditcard-fill", "icon": "icon-creditcard-fill"},
    {"name": "audit", "icon": "icon-audit"},
    {"name": "fund-fill", "icon": "icon-fund-fill"},
    {"name": "diff", "icon": "icon-diff"},
    {"name": "read-fill", "icon": "icon-read-fill"},
    {"name": "Batchfolding", "icon": "icon-Batchfolding"},
    {"name": "contacts-fill", "icon": "icon-contacts-fill"},
    {"name": "securityscan", "icon": "icon-securityscan"},
    {"name": "delete-fill", "icon": "icon-delete-fill"},
    {"name": "propertysafety", "icon": "icon-propertysafety"},
    {"name": "notification-fill", "icon": "icon-notification-fill"},
    {"name": "safetycertificate", "icon": "icon-safetycertificate"},
    {"name": "flag-fill", "icon": "icon-flag-fill"},
    {"name": "insurance", "icon": "icon-insurance"},
    {"name": "moneycollect-fill", "icon": "icon-moneycollect-fill"},
    {"name": "alert", "icon": "icon-alert"},
    {"name": "medicinebox-fill", "icon": "icon-medicinebox-fill"},
    {"name": "delete", "icon": "icon-delete"},
    {"name": "rest-fill", "icon": "icon-rest-fill"},
    {"name": "hourglass", "icon": "icon-hourglass"},
    {"name": "shopping-fill", "icon": "icon-shopping-fill"},
    {"name": "bulb", "icon": "icon-bulb"},
    {"name": "skin-fill", "icon": "icon-skin-fill"},
    {"name": "experiment", "icon": "icon-experiment"},
    {"name": "video-fill", "icon": "icon-video-fill"},
    {"name": "bell", "icon": "icon-bell"},
    {"name": "sound-fill", "icon": "icon-sound-fill"},
    {"name": "trophy", "icon": "icon-trophy"},
    {"name": "bulb-fill", "icon": "icon-bulb-fill"},
    {"name": "rest", "icon": "icon-rest"},
    {"name": "bell-fill", "icon": "icon-bell-fill"},
    {"name": "USB", "icon": "icon-USB"},
    {"name": "filter-fill", "icon": "icon-filter-fill"},
    {"name": "skin", "icon": "icon-skin"},
    {"name": "fire-fill", "icon": "icon-fire-fill"},
    {"name": "home", "icon": "icon-home"},
    {"name": "funnelplot-fill", "icon": "icon-funnelplot-fill"},
    {"name": "bank", "icon": "icon-bank"},
    {"name": "gift-fill", "icon": "icon-gift-fill"},
    {"name": "filter", "icon": "icon-filter"},
    {"name": "hourglass-fill", "icon": "icon-hourglass-fill"},
    {"name": "funnelplot", "icon": "icon-funnelplot"},
    {"name": "home-fill", "icon": "icon-home-fill"},
    {"name": "like", "icon": "icon-like"},
    {"name": "trophy-fill", "icon": "icon-trophy-fill"},
    {"name": "unlike", "icon": "icon-unlike"},
    {"name": "location-fill", "icon": "icon-location-fill"},
    {"name": "unlock", "icon": "icon-unlock"},
    {"name": "cloud-fill", "icon": "icon-cloud-fill"},
    {"name": "lock", "icon": "icon-lock"},
    {"name": "customerservice-fill", "icon": "icon-customerservice-fill"},
    {"name": "customerservice", "icon": "icon-customerservice"},
    {"name": "experiment-fill", "icon": "icon-experiment-fill"},
    {"name": "flag", "icon": "icon-flag"},
    {"name": "eye-fill", "icon": "icon-eye-fill"},
    {"name": "moneycollect", "icon": "icon-moneycollect"},
    {"name": "like-fill", "icon": "icon-like-fill"},
    {"name": "medicinebox", "icon": "icon-medicinebox"},
    {"name": "lock-fill", "icon": "icon-lock-fill"},
    {"name": "shop", "icon": "icon-shop"},
    {"name": "unlike-fill", "icon": "icon-unlike-fill"},
    {"name": "rocket", "icon": "icon-rocket"},
    {"name": "star-fill", "icon": "icon-star-fill"},
    {"name": "shopping", "icon": "icon-shopping"},
    {"name": "unlock-fill", "icon": "icon-unlock-fill"},
    {"name": "folder", "icon": "icon-folder"},
    {"name": "alert-fill", "icon": "icon-alert-fill"},
    {"name": "folder-open", "icon": "icon-folder-open"},
    {"name": "api-fill", "icon": "icon-api-fill"},
    {"name": "folder-add", "icon": "icon-folder-add"},
    {"name": "highlight-fill", "icon": "icon-highlight-fill"},
    {"name": "deploymentunit", "icon": "icon-deploymentunit"},
    {"name": "phone-fill", "icon": "icon-phone-fill"},
    {"name": "accountbook", "icon": "icon-accountbook"},
    {"name": "edit-fill", "icon": "icon-edit-fill"},
    {"name": "contacts", "icon": "icon-contacts"},
    {"name": "pushpin-fill", "icon": "icon-pushpin-fill"},
    {"name": "carryout", "icon": "icon-carryout"},
    {"name": "rocket-fill", "icon": "icon-rocket-fill"},
    {"name": "calendar-check", "icon": "icon-calendar-check"},
    {"name": "thunderbolt-fill", "icon": "icon-thunderbolt-fill"},
    {"name": "calendar", "icon": "icon-calendar"},
    {"name": "tag-fill", "icon": "icon-tag-fill"},
    {"name": "scan", "icon": "icon-scan"},
    {"name": "wrench-fill", "icon": "icon-wrench-fill"},
    {"name": "select", "icon": "icon-select"},
    {"name": "tags-fill", "icon": "icon-tags-fill"},
    {"name": "boxplot", "icon": "icon-boxplot"},
    {"name": "bank-fill", "icon": "icon-bank-fill"},
    {"name": "build", "icon": "icon-build"},
    {"name": "camera-fill", "icon": "icon-camera-fill"},
    {"name": "sliders", "icon": "icon-sliders"},
    {"name": "error-fill", "icon": "icon-error-fill"},
    {"name": "laptop", "icon": "icon-laptop"},
    {"name": "crown-fill", "icon": "icon-crown-fill"},
    {"name": "barcode", "icon": "icon-barcode"},
    {"name": "mail-fill", "icon": "icon-mail-fill"},
    {"name": "camera", "icon": "icon-camera"},
    {"name": "car-fill", "icon": "icon-car-fill"},
    {"name": "cluster", "icon": "icon-cluster"},
    {"name": "printer-fill", "icon": "icon-printer-fill"},
    {"name": "gateway", "icon": "icon-gateway"},
    {"name": "shop-fill", "icon": "icon-shop-fill"},
    {"name": "car", "icon": "icon-car"},
    {"name": "setting-fill", "icon": "icon-setting-fill"},
    {"name": "printer", "icon": "icon-printer"},
    {"name": "USB-fill", "icon": "icon-USB-fill"},
    {"name": "read", "icon": "icon-read"},
    {"name": "golden-fill", "icon": "icon-golden-fill"},
    {"name": "cloud-server", "icon": "icon-cloud-server"},
    {"name": "build-fill", "icon": "icon-build-fill"},
    {"name": "cloud-upload", "icon": "icon-cloud-upload"},
    {"name": "boxplot-fill", "icon": "icon-boxplot-fill"},
    {"name": "cloud", "icon": "icon-cloud"},
    {"name": "sliders-fill", "icon": "icon-sliders-fill"},
    {"name": "cloud-download", "icon": "icon-cloud-download"},
    {"name": "alibaba", "icon": "icon-alibaba"},
    {"name": "cloud-sync", "icon": "icon-cloud-sync"},
    {"name": "alibabacloud", "icon": "icon-alibabacloud"},
    {"name": "video", "icon": "icon-video"},
    {"name": "antdesign", "icon": "icon-antdesign"},
    {"name": "notification", "icon": "icon-notification"},
    {"name": "ant-cloud", "icon": "icon-ant-cloud"},
    {"name": "sound", "icon": "icon-sound"},
    {"name": "behance", "icon": "icon-behance"},
    {"name": "radarchart", "icon": "icon-radarchart"},
    {"name": "googleplus", "icon": "icon-googleplus"},
    {"name": "qrcode", "icon": "icon-qrcode"},
    {"name": "medium", "icon": "icon-medium"},
    {"name": "fund", "icon": "icon-fund"},
    {"name": "google", "icon": "icon-google"},
    {"name": "image", "icon": "icon-image"},
    {"name": "IE", "icon": "icon-IE"},
    {"name": "mail", "icon": "icon-mail"},
    {"name": "amazon", "icon": "icon-amazon"},
    {"name": "table", "icon": "icon-table"},
    {"name": "slack", "icon": "icon-slack"},
    {"name": "idcard", "icon": "icon-idcard"},
    {"name": "alipay", "icon": "icon-alipay"},
    {"name": "creditcard", "icon": "icon-creditcard"},
    {"name": "taobao", "icon": "icon-taobao"},
    {"name": "heart", "icon": "icon-heart"},
    {"name": "zhihu", "icon": "icon-zhihu"},
    {"name": "block", "icon": "icon-block"},
    {"name": "HTML5", "icon": "icon-HTML5"},
    {"name": "error", "icon": "icon-error"},
    {"name": "linkedin", "icon": "icon-linkedin"},
    {"name": "star", "icon": "icon-star"},
    {"name": "yahoo", "icon": "icon-yahoo"},
    {"name": "gold", "icon": "icon-gold"},
    {"name": "facebook", "icon": "icon-facebook"},
    {"name": "heatmap", "icon": "icon-heatmap"},
    {"name": "skype", "icon": "icon-skype"},
    {"name": "wifi", "icon": "icon-wifi"},
    {"name": "CodeSandbox", "icon": "icon-CodeSandbox"},
    {"name": "attachment", "icon": "icon-attachment"},
    {"name": "chrome", "icon": "icon-chrome"},
    {"name": "edit", "icon": "icon-edit"},
    {"name": "codepen", "icon": "icon-codepen"},
    {"name": "key", "icon": "icon-key"},
    {"name": "aliwangwang", "icon": "icon-aliwangwang"},
    {"name": "api", "icon": "icon-api"},
    {"name": "apple", "icon": "icon-apple"},
    {"name": "disconnect", "icon": "icon-disconnect"},
    {"name": "android", "icon": "icon-android"},
    {"name": "highlight", "icon": "icon-highlight"},
    {"name": "sketch", "icon": "icon-sketch"},
    {"name": "monitor", "icon": "icon-monitor"},
    {"name": "Gitlab", "icon": "icon-Gitlab"},
    {"name": "link", "icon": "icon-link"},
    {"name": "dribbble", "icon": "icon-dribbble"},
    {"name": "man", "icon": "icon-man"},
    {"name": "instagram", "icon": "icon-instagram"},
    {"name": "percentage", "icon": "icon-percentage"},
    {"name": "reddit", "icon": "icon-reddit"},
    {"name": "pushpin", "icon": "icon-pushpin"},
    {"name": "windows", "icon": "icon-windows"},
    {"name": "phone", "icon": "icon-phone"},
    {"name": "yuque", "icon": "icon-yuque"},
    {"name": "shake", "icon": "icon-shake"},
    {"name": "Youtube", "icon": "icon-Youtube"},
    {"name": "tag", "icon": "icon-tag"},
    {"name": "Gitlab-fill", "icon": "icon-Gitlab-fill"},
    {"name": "wrench", "icon": "icon-wrench"},
    {"name": "dropbox", "icon": "icon-dropbox"},
    {"name": "tags", "icon": "icon-tags"},
    {"name": "dingtalk", "icon": "icon-dingtalk"},
    {"name": "scissor", "icon": "icon-scissor"},
    {"name": "android-fill", "icon": "icon-android-fill"},
    {"name": "mr", "icon": "icon-mr"},
    {"name": "apple-fill", "icon": "icon-apple-fill"},
    {"name": "share", "icon": "icon-share"},
    {"name": "HTML5-fill", "icon": "icon-HTML5-fill"},
    {"name": "branches", "icon": "icon-branches"},
    {"name": "windows-fill", "icon": "icon-windows-fill"},
    {"name": "fork", "icon": "icon-fork"},
    {"name": "QQ", "icon": "icon-QQ"},
    {"name": "shrink", "icon": "icon-shrink"},
    {"name": "twitter", "icon": "icon-twitter"},
    {"name": "arrawsalt", "icon": "icon-arrawsalt"},
    {"name": "skype-fill", "icon": "icon-skype-fill"},
    {"name": "verticalright", "icon": "icon-verticalright"},
    {"name": "weibo", "icon": "icon-weibo"},
    {"name": "verticalleft", "icon": "icon-verticalleft"},
    {"name": "yuque-fill", "icon": "icon-yuque-fill"},
    {"name": "right", "icon": "icon-right"},
    {"name": "Youtube-fill", "icon": "icon-Youtube-fill"},
    {"name": "left", "icon": "icon-left"},
    {"name": "yahoo-fill", "icon": "icon-yahoo-fill"},
    {"name": "up", "icon": "icon-up"},
    {"name": "wechat-fill", "icon": "icon-wechat-fill"},
    {"name": "down", "icon": "icon-down"},
    {"name": "chrome-fill", "icon": "icon-chrome-fill"},
    {"name": "fullscreen", "icon": "icon-fullscreen"},
    {"name": "alipay-circle-fill", "icon": "icon-alipay-circle-fill"},
    {"name": "fullscreen-exit", "icon": "icon-fullscreen-exit"},
    {"name": "aliwangwang-fill", "icon": "icon-aliwangwang-fill"},
    {"name": "doubleleft", "icon": "icon-doubleleft"},
    {"name": "behance-circle-fill", "icon": "icon-behance-circle-fill"},
    {"name": "doubleright", "icon": "icon-doubleright"},
    {"name": "amazon-circle-fill", "icon": "icon-amazon-circle-fill"},
    {"name": "arrowright", "icon": "icon-arrowright"},
    {"name": "codepen-circle-fill", "icon": "icon-codepen-circle-fill"},
    {"name": "arrowup", "icon": "icon-arrowup"},
    {"name": "CodeSandbox-circle-f", "icon": "icon-CodeSandbox-circle-f"},
    {"name": "arrowleft", "icon": "icon-arrowleft"},
    {"name": "dropbox-circle-fill", "icon": "icon-dropbox-circle-fill"},
    {"name": "arrowdown", "icon": "icon-arrowdown"},
    {"name": "github-fill", "icon": "icon-github-fill"},
    {"name": "upload", "icon": "icon-upload"},
    {"name": "dribbble-circle-fill", "icon": "icon-dribbble-circle-fill"},
    {"name": "colum-height", "icon": "icon-colum-height"},
    {"name": "googleplus-circle-f", "icon": "icon-googleplus-circle-f"},
    {"name": "vertical-align-botto", "icon": "icon-vertical-align-botto"},
    {"name": "medium-circle-fill", "icon": "icon-medium-circle-fill"},
    {"name": "vertical-align-middl", "icon": "icon-vertical-align-middl"},
    {"name": "QQ-circle-fill", "icon": "icon-QQ-circle-fill"},
    {"name": "totop", "icon": "icon-totop"},
    {"name": "IE-circle-fill", "icon": "icon-IE-circle-fill"},
    {"name": "vertical-align-top", "icon": "icon-vertical-align-top"},
    {"name": "google-circle-fill", "icon": "icon-google-circle-fill"},
    {"name": "download", "icon": "icon-download"},
    {"name": "dingtalk-circle-fill", "icon": "icon-dingtalk-circle-fill"},
    {"name": "sort-descending", "icon": "icon-sort-descending"},
    {"name": "sketch-circle-fill", "icon": "icon-sketch-circle-fill"},
    {"name": "sort-ascending", "icon": "icon-sort-ascending"},
    {"name": "slack-circle-fill", "icon": "icon-slack-circle-fill"},
    {"name": "fall", "icon": "icon-fall"},
    {"name": "twitter-circle-fill", "icon": "icon-twitter-circle-fill"},
    {"name": "swap", "icon": "icon-swap"},
    {"name": "taobao-circle-fill", "icon": "icon-taobao-circle-fill"},
    {"name": "stock", "icon": "icon-stock"},
    {"name": "weibo-circle-fill", "icon": "icon-weibo-circle-fill"},
    {"name": "rise", "icon": "icon-rise"},
    {"name": "zhihu-circle-fill", "icon": "icon-zhihu-circle-fill"},
    {"name": "indent", "icon": "icon-indent"},
    {"name": "reddit-circle-fill", "icon": "icon-reddit-circle-fill"},
    {"name": "outdent", "icon": "icon-outdent"},
    {"name": "alipay-square-fill", "icon": "icon-alipay-square-fill"},
    {"name": "menu", "icon": "icon-menu"},
    {"name": "dingtalk-square-fill", "icon": "icon-dingtalk-square-fill"},
    {"name": "unorderedlist", "icon": "icon-unorderedlist"},
    {"name": "CodeSandbox-square-f", "icon": "icon-CodeSandbox-square-f"},
    {"name": "orderedlist", "icon": "icon-orderedlist"},
    {"name": "behance-square-fill", "icon": "icon-behance-square-fill"},
    {"name": "align-right", "icon": "icon-align-right"},
    {"name": "amazon-square-fill", "icon": "icon-amazon-square-fill"},
    {"name": "align-center", "icon": "icon-align-center"},
    {"name": "codepen-square-fill", "icon": "icon-codepen-square-fill"},
    {"name": "align-left", "icon": "icon-align-left"},
    {"name": "dribbble-square-fill", "icon": "icon-dribbble-square-fill"},
    {"name": "pic-center", "icon": "icon-pic-center"},
    {"name": "dropbox-square-fill", "icon": "icon-dropbox-square-fill"},
    {"name": "pic-right", "icon": "icon-pic-right"},
    {"name": "facebook-fill", "icon": "icon-facebook-fill"},
    {"name": "pic-left", "icon": "icon-pic-left"},
    {"name": "googleplus-square-f", "icon": "icon-googleplus-square-f"},
    {"name": "bold", "icon": "icon-bold"},
    {"name": "google-square-fill", "icon": "icon-google-square-fill"},
    {"name": "font-colors", "icon": "icon-font-colors"},
    {"name": "instagram-fill", "icon": "icon-instagram-fill"},
    {"name": "exclaimination", "icon": "icon-exclaimination"},
    {"name": "IE-square-fill", "icon": "icon-IE-square-fill"},
    {"name": "check-circle", "icon": "icon-check-circle"},
    {"name": "font-size", "icon": "icon-font-size"},
    {"name": "medium-square-fill", "icon": "icon-medium-square-fill"},
    {"name": "CI", "icon": "icon-CI"},
    {"name": "infomation", "icon": "icon-infomation"},
    {"name": "linkedin-fill", "icon": "icon-linkedin-fill"},
    {"name": "Dollar", "icon": "icon-Dollar"},
    {"name": "line-height", "icon": "icon-line-height"},
    {"name": "QQ-square-fill", "icon": "icon-QQ-square-fill"},
    {"name": "compass", "icon": "icon-compass"},
    {"name": "strikethrough", "icon": "icon-strikethrough"},
    {"name": "reddit-square-fill", "icon": "icon-reddit-square-fill"},
    {"name": "close-circle", "icon": "icon-close-circle"},
    {"name": "underline", "icon": "icon-underline"},
    {"name": "twitter-square-fill", "icon": "icon-twitter-square-fill"},
    {"name": "frown", "icon": "icon-frown"},
    {"name": "number", "icon": "icon-number"},
    {"name": "sketch-square-fill", "icon": "icon-sketch-square-fill"},
    {"name": "info-circle", "icon": "icon-info-circle"},
    {"name": "italic", "icon": "icon-italic"},
    {"name": "slack-square-fill", "icon": "icon-slack-square-fill"},
    {"name": "left-circle", "icon": "icon-left-circle"},
    {"name": "code", "icon": "icon-code"},
    {"name": "taobao-square-fill", "icon": "icon-taobao-square-fill"},
    {"name": "down-circle", "icon": "icon-down-circle"},
    {"name": "column-width", "icon": "icon-column-width"},
    {"name": "weibo-square-fill", "icon": "icon-weibo-square-fill"},
    {"name": "EURO", "icon": "icon-EURO"},
    {"name": "check", "icon": "icon-check"},
    {"name": "zhihu-square-fill", "icon": "icon-zhihu-square-fill"},
    {"name": "copyright", "icon": "icon-copyright"},
    {"name": "ellipsis", "icon": "icon-ellipsis"},
    {"name": "zoomout", "icon": "icon-zoomout"},
    {"name": "minus-circle", "icon": "icon-minus-circle"},
    {"name": "dash", "icon": "icon-dash"},
    {"name": "apartment", "icon": "icon-apartment"},
    {"name": "meh", "icon": "icon-meh"},
    {"name": "close", "icon": "icon-close"},
    {"name": "audio", "icon": "icon-audio"},
    {"name": "plus-circle", "icon": "icon-plus-circle"},
    {"name": "enter", "icon": "icon-enter"},
    {"name": "audio-fill", "icon": "icon-audio-fill"},
    {"name": "play-circle", "icon": "icon-play-circle"},
    {"name": "line", "icon": "icon-line"},
    {"name": "robot", "icon": "icon-robot"},
    {"name": "question-circle", "icon": "icon-question-circle"},
    {"name": "minus", "icon": "icon-minus"},
    {"name": "zoomin", "icon": "icon-zoomin"},
    {"name": "Pound", "icon": "icon-Pound"},
    {"name": "question", "icon": "icon-question"},
    {"name": "robot-fill", "icon": "icon-robot-fill"},
    {"name": "right-circle", "icon": "icon-right-circle"},
    {"name": "rollback", "icon": "icon-rollback"},
    {"name": "bug-fill", "icon": "icon-bug-fill"},
    {"name": "smile", "icon": "icon-smile"},
    {"name": "small-dash", "icon": "icon-small-dash"},
    {"name": "bug", "icon": "icon-bug"},
    {"name": "trademark", "icon": "icon-trademark"},
    {"name": "pause", "icon": "icon-pause"},
    {"name": "audiostatic", "icon": "icon-audiostatic"},
    {"name": "time-circle", "icon": "icon-time-circle"},
    {"name": "bg-colors", "icon": "icon-bg-colors"},
    {"name": "comment", "icon": "icon-comment"},
    {"name": "timeout", "icon": "icon-timeout"},
    {"name": "crown", "icon": "icon-crown"},
    {"name": "signal-fill", "icon": "icon-signal-fill"},
    {"name": "earth", "icon": "icon-earth"},
    {"name": "drag", "icon": "icon-drag"},
    {"name": "verified", "icon": "icon-verified"},
    {"name": "YUAN", "icon": "icon-YUAN"},
    {"name": "desktop", "icon": "icon-desktop"},
    {"name": "shortcut-fill", "icon": "icon-shortcut-fill"},
    {"name": "up-circle", "icon": "icon-up-circle"},
    {"name": "gift", "icon": "icon-gift"},
    {"name": "videocameraadd", "icon": "icon-videocameraadd"},
    {"name": "warning-circle", "icon": "icon-warning-circle"},
    {"name": "stop", "icon": "icon-stop"},
    {"name": "switchuser", "icon": "icon-switchuser"},
    {"name": "sync", "icon": "icon-sync"},
    {"name": "fire", "icon": "icon-fire"},
    {"name": "whatsapp", "icon": "icon-whatsapp"},
    {"name": "transaction", "icon": "icon-transaction"},
    {"name": "thunderbolt", "icon": "icon-thunderbolt"},
    {"name": "appstoreadd", "icon": "icon-appstoreadd"},
    {"name": "undo", "icon": "icon-undo"},
    {"name": "check-circle-fill", "icon": "icon-check-circle-fill"},
    {"name": "caret-down", "icon": "icon-caret-down"},
    {"name": "redo", "icon": "icon-redo"},
    {"name": "left-circle-fill", "icon": "icon-left-circle-fill"},
    {"name": "backward", "icon": "icon-backward"},
    {"name": "reload", "icon": "icon-reload"},
    {"name": "down-circle-fill", "icon": "icon-down-circle-fill"},
    {"name": "caret-up", "icon": "icon-caret-up"},
    {"name": "reloadtime", "icon": "icon-reloadtime"},
    {"name": "minus-circle-fill", "icon": "icon-minus-circle-fill"},
    {"name": "caret-right", "icon": "icon-caret-right"},
    {"name": "message", "icon": "icon-message"},
    {"name": "close-circle-fill", "icon": "icon-close-circle-fill"},
    {"name": "caret-left", "icon": "icon-caret-left"},
    {"name": "dashboard", "icon": "icon-dashboard"},
    {"name": "info-circle-fill", "icon": "icon-info-circle-fill"},
    {"name": "fast-backward", "icon": "icon-fast-backward"},
    {"name": "issuesclose", "icon": "icon-issuesclose"},
    {"name": "up-circle-fill", "icon": "icon-up-circle-fill"},
    {"name": "forward", "icon": "icon-forward"},
    {"name": "poweroff", "icon": "icon-poweroff"},
    {"name": "right-circle-fill", "icon": "icon-right-circle-fill"},
    {"name": "fast-forward", "icon": "icon-fast-forward"},
    {"name": "logout", "icon": "icon-logout"},
    {"name": "plus-circle-fill", "icon": "icon-plus-circle-fill"},
    {"name": "search", "icon": "icon-search"},
    {"name": "piechart", "icon": "icon-piechart"},
    {"name": "question-circle-fill", "icon": "icon-question-circle-fill"},
    {"name": "retweet", "icon": "icon-retweet"},
    {"name": "setting", "icon": "icon-setting"},
    {"name": "EURO-circle-fill", "icon": "icon-EURO-circle-fill"},
    {"name": "login", "icon": "icon-login"},
    {"name": "eye", "icon": "icon-eye"},
    {"name": "frown-fill", "icon": "icon-frown-fill"},
    {"name": "step-backward", "icon": "icon-step-backward"},
    {"name": "location", "icon": "icon-location"},
    {"name": "copyright-circle-fil", "icon": "icon-copyright-circle-fil"},
    {"name": "step-forward", "icon": "icon-step-forward"},
    {"name": "edit-square", "icon": "icon-edit-square"},
    {"name": "CI-circle-fill", "icon": "icon-CI-circle-fill"},
    {"name": "swap-right", "icon": "icon-swap-right"},
    {"name": "export", "icon": "icon-export"},
    {"name": "compass-fill", "icon": "icon-compass-fill"},
    {"name": "swap-left", "icon": "icon-swap-left"},
    {"name": "save", "icon": "icon-save"},
    {"name": "Dollar-circle-fill", "icon": "icon-Dollar-circle-fill"},
    {"name": "woman", "icon": "icon-woman"},
    {"name": "Import", "icon": "icon-Import"},
    {"name": "poweroff-circle-fill", "icon": "icon-poweroff-circle-fill"},
    {"name": "plus", "icon": "icon-plus"},
    {"name": "appstore", "icon": "icon-appstore"},
    {"name": "meh-fill", "icon": "icon-meh-fill"},
    {"name": "eyeclose-fill", "icon": "icon-eyeclose-fill"},
    {"name": "close-square", "icon": "icon-close-square"},
    {"name": "play-circle-fill", "icon": "icon-play-circle-fill"},
    {"name": "eye-close", "icon": "icon-eye-close"},
    {"name": "down-square", "icon": "icon-down-square"},
    {"name": "Pound-circle-fill", "icon": "icon-Pound-circle-fill"},
    {"name": "clear", "icon": "icon-clear"},
    {"name": "layout", "icon": "icon-layout"},
    {"name": "smile-fill", "icon": "icon-smile-fill"},
    {"name": "collapse", "icon": "icon-collapse"},
    {"name": "left-square", "icon": "icon-left-square"},
    {"name": "stop-fill", "icon": "icon-stop-fill"},
    {"name": "expand", "icon": "icon-expand"},
    {"name": "play-square", "icon": "icon-play-square"},
    {"name": "warning-circle-fill", "icon": "icon-warning-circle-fill"},
    {"name": "deletecolumn", "icon": "icon-deletecolumn"},
    {"name": "control", "icon": "icon-control"},
    {"name": "time-circle-fill", "icon": "icon-time-circle-fill"},
    {"name": "merge-cells", "icon": "icon-merge-cells"},
    {"name": "codelibrary", "icon": "icon-codelibrary"},
    {"name": "trademark-circle-fil", "icon": "icon-trademark-circle-fil"},
    {"name": "subnode", "icon": "icon-subnode"},
    {"name": "detail", "icon": "icon-detail"},
    {"name": "YUAN-circle-fill", "icon": "icon-YUAN-circle-fill"},
    {"name": "rotate-left", "icon": "icon-rotate-left"},
    {"name": "minus-square", "icon": "icon-minus-square"},
    {"name": "heart-fill", "icon": "icon-heart-fill"},
    {"name": "rotate-right", "icon": "icon-rotate-right"},
    {"name": "plus-square", "icon": "icon-plus-square"},
    {"name": "piechart-circle-fil", "icon": "icon-piechart-circle-fil"},
    {"name": "insertrowbelow", "icon": "icon-insertrowbelow"},
    {"name": "right-square", "icon": "icon-right-square"},
    {"name": "dashboard-fill", "icon": "icon-dashboard-fill"},
    {"name": "insertrowabove", "icon": "icon-insertrowabove"},
    {"name": "project", "icon": "icon-project"},
    {"name": "message-fill", "icon": "icon-message-fill"},
    {"name": "table", "icon": "icon-table"},
    {"name": "wallet", "icon": "icon-wallet"},
    {"name": "check-square-fill", "icon": "icon-check-square-fill"},
    {"name": "solit-cells", "icon": "icon-solit-cells"},
    {"name": "up-square", "icon": "icon-up-square"},
    {"name": "down-square-fill", "icon": "icon-down-square-fill"},
    {"name": "formatpainter", "icon": "icon-formatpainter"},
    {"name": "calculator", "icon": "icon-calculator"},
    {"name": "minus-square-fill", "icon": "icon-minus-square-fill"},
    {"name": "insertrowright", "icon": "icon-insertrowright"},
    {"name": "interation", "icon": "icon-interation"},
    {"name": "close-square-fill", "icon": "icon-close-square-fill"},
    {"name": "formatpainter-fill", "icon": "icon-formatpainter-fill"},
    {"name": "check-square", "icon": "icon-check-square"},
    {"name": "codelibrary-fill", "icon": "icon-codelibrary-fill"},
    {"name": "insertrowleft", "icon": "icon-insertrowleft"},
    {"name": "border", "icon": "icon-border"},
    {"name": "left-square-fill", "icon": "icon-left-square-fill"},
    {"name": "translate", "icon": "icon-translate"},
    {"name": "border-outer", "icon": "icon-border-outer"},
    {"name": "play-square-fill", "icon": "icon-play-square-fill"},
    {"name": "deleterow", "icon": "icon-deleterow"},
    {"name": "border-top", "icon": "icon-border-top"},
    {"name": "up-square-fill", "icon": "icon-up-square-fill"},
    {"name": "sisternode", "icon": "icon-sisternode"},
    {"name": "border-bottom", "icon": "icon-border-bottom"},
    {"name": "right-square-fill", "icon": "icon-right-square-fill"},
    {"name": "Field-number", "icon": "icon-Field-number"},
    {"name": "border-left", "icon": "icon-border-left"},
    {"name": "plus-square-fill", "icon": "icon-plus-square-fill"},
    {"name": "Field-String", "icon": "icon-Field-String"},
    {"name": "border-right", "icon": "icon-border-right"},
    {"name": "accountbook-fill", "icon": "icon-accountbook-fill"},
    {"name": "Function", "icon": "icon-Function"},
    {"name": "border-inner", "icon": "icon-border-inner"},
    {"name": "carryout-fill", "icon": "icon-carryout-fill"},
    {"name": "Field-time", "icon": "icon-Field-time"},
    {"name": "border-verticle", "icon": "icon-border-verticle"},
    {"name": "calendar-fill", "icon": "icon-calendar-fill"},
    {"name": "GIF", "icon": "icon-GIF"},
    {"name": "border-horizontal", "icon": "icon-border-horizontal"},
    {"name": "calculator-fill", "icon": "icon-calculator-fill"},
    {"name": "Partition", "icon": "icon-Partition"},
    {"name": "radius-bottomleft", "icon": "icon-radius-bottomleft"},
    {"name": "interation-fill", "icon": "icon-interation-fill"},
    {"name": "index", "icon": "icon-index"},
    {"name": "radius-bottomright", "icon": "icon-radius-bottomright"},
    {"name": "project-fill", "icon": "icon-project-fill"},
    {"name": "Storedprocedure", "icon": "icon-Storedprocedure"},
    {"name": "radius-upleft", "icon": "icon-radius-upleft"},
    {"name": "detail-fill", "icon": "icon-detail-fill"},
    {"name": "Field-Binary", "icon": "icon-Field-Binary"},
    {"name": "radius-upright", "icon": "icon-radius-upright"},
    {"name": "save-fill", "icon": "icon-save-fill"},
    {"name": "Console-SQL", "icon": "icon-Console-SQL"},
    {"name": "radius-setting", "icon": "icon-radius-setting"},
    {"name": "wallet-fill", "icon": "icon-wallet-fill"},
    {"name": "0.042361111", "icon": "icon-0.042361111"},
    {"name": "adduser", "icon": "icon-adduser"},
    {"name": "control-fill", "icon": "icon-control-fill"},
    {"name": "aim", "icon": "icon-aim"},
    {"name": "deleteteam", "icon": "icon-deleteteam"},
    {"name": "layout-fill", "icon": "icon-layout-fill"},
    {"name": "compress", "icon": "icon-compress"},
    {"name": "deleteuser", "icon": "icon-deleteuser"},
    {"name": "appstore-fill", "icon": "icon-appstore-fill"},
    {"name": "expend", "icon": "icon-expend"},
    {"name": "addteam", "icon": "icon-addteam"},
    {"name": "mobile-fill", "icon": "icon-mobile-fill"},
    {"name": "folder-view", "icon": "icon-folder-view"},
    {"name": "user", "icon": "icon-user"},
    {"name": "tablet-fill", "icon": "icon-tablet-fill"},
    {"name": "file-GIF", "icon": "icon-file-GIF"},
    {"name": "team", "icon": "icon-team"},
    {"name": "book-fill", "icon": "icon-book-fill"},
    {"name": "group", "icon": "icon-group"},
    {"name": "areachart", "icon": "icon-areachart"},
    {"name": "redenvelope-fill", "icon": "icon-redenvelope-fill"},
    {"name": "send", "icon": "icon-send"},
    {"name": "linechart", "icon": "icon-linechart"},
    {"name": "safetycertificate-f", "icon": "icon-safetycertificate-f"},
    {"name": "Report", "icon": "icon-Report"},
    {"name": "barchart", "icon": "icon-barchart"},
    {"name": "propertysafety-fill", "icon": "icon-propertysafety-fill"},
    {"name": "View", "icon": "icon-View"},
    {"name": "pointmap", "icon": "icon-pointmap"},
    {"name": "insurance-fill", "icon": "icon-insurance-fill"},
    {"name": "shortcut", "icon": "icon-shortcut"},
    {"name": "container", "icon": "icon-container"},
    {"name": "securityscan-fill", "icon": "icon-securityscan-fill"},
    {"name": "ungroup", "icon": "icon-ungroup"},
    {"name": "database", "icon": "icon-database"},
    {"name": "file-exclamation-fil", "icon": "icon-file-exclamation-fil"},
    {"name": "sever", "icon": "icon-sever"},
    {"name": "file-add-fill", "icon": "icon-file-add-fill"},
    {"name": "mobile", "icon": "icon-mobile"},
    {"name": "file-fill", "icon": "icon-file-fill"},
    {"name": "tablet", "icon": "icon-tablet"},
    {"name": "file-excel-fill", "icon": "icon-file-excel-fill"},
    {"name": "redenvelope", "icon": "icon-redenvelope"},
    {"name": "file-markdown-fill", "icon": "icon-file-markdown-fill"},
    {"name": "book", "icon": "icon-book"},
    {"name": "file-text-fill", "icon": "icon-file-text-fill"},
    {"name": "filedone", "icon": "icon-filedone"},
    {"name": "file-ppt-fill", "icon": "icon-file-ppt-fill"},
    {"name": "reconciliation", "icon": "icon-reconciliation"},
    {"name": "file-unknown-fill", "icon": "icon-file-unknown-fill"},
    {"name": "file-exception", "icon": "icon-file-exception"},
    {"name": "file-word-fill", "icon": "icon-file-word-fill"},
]
